import { DirectSpendLimitType, DirectStrategyType } from '../data-layer/direct/types';

export const disableContentPromotionMetrics = (
    strategyType: DirectStrategyType,
    spendLimitType?: DirectSpendLimitType,
) =>
    strategyType === DirectStrategyType.MAX_CLICKS &&
    spendLimitType === DirectSpendLimitType.AVERAGE_CPC;
